import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-table-grey',
  templateUrl: './table-grey.component.html',
  styleUrls: ['./table-grey.component.css']
})
export class TableGreyComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
